<template>
  <div class="home">
    <div class="banner" :class="!showCount&&'no-count'">
      <!-- <img :src="`//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/banner/banner_wide2024-1.png`"> -->
      <!-- <transition name="banner">
        <div v-show="show"  style="transition: all ease-out 0.5s;overflow: hidden;" id="banner-id">
          <div class="swiper-wrapper">
            <div class="swiper-slide flex"><img :src="`//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/banner/banner_wide2024-1.png`"></div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </transition> -->
      <!-- <div v-if="showCount" class="curve">
        <transition name="conut">
          <div v-show="show" style="transition: all ease-out 0.5s;">
            <h2>距第四届博览会开幕还有</h2>
            <div class="flex timer">
              <div class="d">{{d}}</div>
              <div class="h">{{h}}</div>
              <div class="m">{{m}}</div>
              <div class="s">{{s}}</div>
            </div>
            <div class="flex timer">
              <div class="timer2">天</div>
              <div class="timer2">时</div>
              <div class="timer2">分</div>
              <div class="timer2">秒</div>
            </div>
          </div>
        </transition>
      </div> -->
    </div>
    <div class="flex sign-wrap">
      <div class="flex centerr">
        <router-link tag="a" to="/sign/1" class="flex sign-item">
          <img src="data:image/png;base64,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">
          <h4>Audience Registration</h4>
        </router-link>
        <router-link tag="a" to="/media-sign" class="flex sign-item">
          <img src="data:image/png;base64,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">
          <h4>Media Registration</h4>
        </router-link>
        <router-link tag="a" to="/sign/2" class="flex sign-item">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAACHCAYAAAA850oKAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAACY9JREFUeJztnW2sHUUZgJ/tB7a3H1YFKhFrL6LFSuknDRGJJgjWkJCiQCki1K8GbUAFRQWsBPQH6A/9gTFoFFEEjcWGCMEEqjGo2EoF08RysYIWqVjB0vrR9tKOP9678XR2597deefs2fa8T3LSnOnZd+buec7uuzM7s5lzjoY4G7gGWAzMaKrSI4S/ARuBtcDjTVSYZRlZQ3J8CriliYqOcIaBC4H13a6oKTlOBjYDE7tdUZ+wEzgJeKGblWRZxrhuVjDCckyMlBwDvL2JipqQ440N1NFvNLJPm5BjqIE6+o1G9mkTcqxHEikjDTuBnzdRURNybAGua6CefmAYWE2Xk9GcJuQA+BLwTuAhYFdDdR5JPAfcC5xKA5exOU31cxiHGU1dyhqHKSaHEcTkMIKYHEYQk8MIYnIYQUwOI4jJYQTplhyTkG7eh4AdgLNXstcB4I/AOqTXuWt0o4f0LOAO4NWpAxulbARWAE+nDNqNHtKPAg9gYjTJUuDRkX+TkvLIcToylDwhVUCjFn8BFpJoxDblkWMC8G1MjF4yi8Q3caeSYxXwhkSxjHguA05MFSyFHEcB1yeIY+iZANyQKlgKOVYDr0sQx0jDSmBuikDahHQysA04LkVjjGSsA87XBEiRkK5BJ8YW/j898gqkkyeGTcjkqVcC10Zs/zVgJjAI3Fdz273ApcB04Axge0T9AP9CvtBpyNTR5yLjALwbuXLR4ZyLfU11zu10OhZ4Me+OjHOSF+f+GtsOOefGdWw7zTm3t8b2X/bqPq/Gtp2s9eKsjIyT8xMX/90Cupzj48DRiu0fBh7zyv4cEWc7sFURZwtwsOP9Hur1Nvp1PUjcEdCP8yN0R49zgNMU20fLMQO4WlMxcFtJ2Tsi4jxaUjanxvZlX+TBkrIQfl17gCdrbJ9zlvd+GOk70vAFzcaxcnwS3TIKu5BfRieLgUURsXw5MlKcb6uzuKSsTNixeA/wCq/sm8TnYQBnophXGyPH0cDHYisc4Q7gv17Z6shY/hfxeppd/2M+MN4ri5FjEtKJ1ck2ZGRbQ/TRI0aOzwBTYysc4Rve+6nI9XkM/hdR9kvuJpMp9ivEyAHw4ZKystNvHU4HlsVsWFeO45CRVw2/QpLATlYil3B1eQb4u1fWtBxldW4m7nQwF3irV7ae4t9Yl5tiNqorx3XIL0VD2S8h1SkF2iHHbuSGnBj8fTEM3B4ZK2cJsk5KLerIMYvyw14dXgR+6JUtRBofQ5kcTSajOamSUpCOMD9n0iamADciyXpl6sixFhlk0/Bd0iWiUJ6M+hl/E6RKSkGOzJd6ZU8CP4uMlzMPuWOsMlXlOJFiJh2Dn4hOAS5WxOt1MpozALzJK4uVA7qTmIKM2PoSB6kqxw3ob+R5BPi9V3YRMiYRw18p9iD2So6yumOTUpBxord4ZT8G/hEZL2cO8L6qH64ix1ziLzM7SZmIQnuS0VDdLyL9FLH4+2Y/+sQUJD2otIBfFTlurPi50dgN/MArm4/uptgyOWJ6WFORMikFuAB4uVfmn5ZjGAQ+WOWDY33pC5HhXy3fA/7jlWmOGlDc8SfQm2Q0ZwHpklKQPMY/BQyRZj2w65Ee2VEZS46bqHn5E8A/pQwA71XGbEsymjOALB7biUYO6F5i+hrg8rE+NJocpyHDvlo2UlyvewXFQ2YdnkXWA++k13JA2qQU4BSKw+73AM8rYuZ8FrlaDDKaHKrh3g5SJ6LQvmQ0x2/DLuBPypj+vtoHfEcZE+BY5O67ICE53oYM92rZA9ztlc1DeRMK7UtGc1InpSBHWf9yP0ViCvLAgmBXQkiOVEeNO4F/e2XaowYUd/ggcv9or1lAcZ9q5RgALvHKtgK/UMYF2WdXhf6zTI5lFEcGY/FPKZMp/qExtC0ZzZlC+qQUupeYAnyCwA+rTI6o4d0Sfgv8ziu7EP2NODtGXp20RQ4otiWFHAso9gmtI8282OnIQ5IK+HIsJ36E1KcbiSi0NxnN6UZSCsV9txe5oy4FVyBTMw6hU44M6Q1NhX97W9l4QQxPlJRpktGyfhxNj3CZqGVtrstFFG+I0t5CmDOAXNoeQudOWIFcSaTCnyK5JlHc2d77RcCrFPFO5tD9MK2kjjosodhTm2K66BRkwnrquDmXA8cfUjIyiWW8c26rchKNzx+cc0udc9Odc6udcy8linvAOXeVc26Gc26+c+7xBDFvdc4d65yb7WQykJb7nXMnjMT8aoJ4Obucc+c6mVD2LqefVObzddcxqSmfK7sK/RwJ4/BnGBnWfyqfKzsRGcY1jInA5/M345BEZ7BnzTHaxiXAa0HkeH9v22K0jPGM3CowjnaMSRjtYhGIHHUmDRv9wUEQOTb0uCFG+9gAcik7G/g1trCsIWwAlmVZNjwOWahkHvIEx60U7/U0jnz+iUwduRJZT12eA+wUSwM55+6q0Ou2XFmH5nVOhfat62H7Yl/XVvi7PqepA+yRGsYomBxGEJPDCGJyGEFMDiOIyWEEMTmMICaHEcTkMIKYHEYQk8MIYnIYQUwOI4jJYQQxOYwgJocRxOQwgpgcRhCTwwhichhBTA4jiPZJCE1wPLKA3UzkObQPAwd62qI+oe1yXIMsRfWyjrJNyEzwoZ60qI9o82llFXAzh4oBcCpwL/pnzRlj0GY5bh7l/+YAH2iqIf1KW+UYRNbmHg3tEtnGGLRVjipon5ZojEFb5XiKsR+0+5smGtLPtFUOgE+P8n9PAN9qqiH9SpvluB0RZJ9Xvgk4l+LzaY3EtL2f4xbg+8AZSIL6GPBL4KVeNqpfaLscAM8Ad/W6Ef1Im08rRo8xOYwgJocRxOQwgpgcRhCTwwhichhBTA4jiMlhBDE5jCAmhxHE5DCCmBxGEJPDCGJyGEFMDiOIyWEEMTmMICaHEcTkMIKYHEYQk8MIYnIYQUwOI4jJYQQxOYwgJocRRCtHlQVUTMD0ZE1Uov3iXqjwmVOUdRhFquzT57WVaOV4tsJnrgbOByYp6zJgGnAlcEGFz1b5bkYlc061tNbZwE+1jTC6wixge+zGWZap5TgK2AlM1wQxkrMZWKwJkGWZ+rSyH1meyWgXt6UIoj1yABwDbEPOh0bvGQLejHJprBRHDpDTykcSxDH07AMuI9Gaaan6IO4EvpgolhHHQeBDwCOpAqY4rXSyBvgKh8dCdEcSu4GLgftSBUx1WunkVmAp8GDiuEY5DlmKcz4JxchJfeToZAlwHnAm8kCdmdgRRct+YAfwNPAAcA9deu5MlmX8D8UdQtn/b5lHAAAAAElFTkSuQmCC">
          <h4>Exhibitor Registration</h4>
        </router-link>
      </div>
    </div>
    <br>
    <!-- <div class="marquee">
      <div class="flex center">
        <div class="flag"><img src="data:image/png;base64,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">媒体报道</div>
        <div class="mq-fixed" id="mq-fixed" @mouseenter="mqFlag = true" @mouseleave="mqFlag = false">
          <table border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td id="mq-wrap1" style="padding-left: 400px;" nowrap><a v-for="(item,index) in aboutList" target="_blank" :href="item.content" :key="index"> • {{item.title}}&nbsp;&nbsp;&nbsp;&nbsp;</a></td>
              <td id="mq-wrap2" nowrap><a v-for="(item,index) in aboutList" target="_blank" :href="item.content" :key="index"> • {{item.title}}&nbsp;&nbsp;&nbsp;&nbsp;</a></td>
            </tr>
          </table>
        </div>
        <router-link tag="a" to="/news">More >></router-link>
      </div>
    </div> -->
    <DTitle text="Exhibition Profile"/>
    <br>
    <br>
    <div class="about center">
      <div class="banner-wrap" ref="bannerList" @mouseover="bannerPlay()" @mouseleave="bannerPlay(true)">
        <!-- 添加Class名为'banner-item'的DOM元素并修改显示索引 -->
        <!-- banner-item内全部使用内联样式 -->
        <div :class="0==bannerShow&&'item-show'" class="banner-item">
          <router-link tag="div" to="/main-forum" class="flex banner-content">
            <div class="img" :style="{'background-image': 'url(//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/banner/sub_banner_1.jpg)'}"></div>
            <div class="text tc">
              <h2>The 6th Zhejiang International Intelligent Transportation Industry Expo</h2>
              <h2> Exhibition</h2><br>
              <p>The 6th edition features the "5+4+X" exhibition model, i.e., five theme pavilions, four special exhibition areas, and X supporting activities.</p>
            </div>
          </router-link>
        </div>
        <div :class="1==bannerShow&&'item-show'" class="banner-item">
          <router-link tag="div" to="/exhibition" class="flex banner-content">
            <div class="img" :style="{'background-image': 'url(//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/banner/sub_banner_2.jpg)'}"></div>
            <div class="text tc">
              <h2>The 6th Zhejiang International Intelligent Transportation Industry Expo</h2>
              <h2>Main Activities</h2><br>
              <p>Focusing on the 6 topics including highway and rail transit, aviation industry (low-altitude economy), port and shipping logistics (shipping services), digital transportation and green and low-carbon development, 6 industry supply and demand matchmaking meetings will be held.</p>
            </div>
          </router-link>
        </div>
      </div>
      <br>
      <div v-show="bannerList != 1" class="banner-legend flex">
        <div v-for="(item, index) in bannerList" :key="index" @click="bannerShow = index,resetTimer()" :class="bannerShow == index? 'cur':''"></div>
      </div>
    </div>
    <!-- <div class="annual-info">
      <div class="flex center">
        <router-link tag="a" to="/second" class="first">
          <DTitle text="Previous Highlights"></DTitle>
          <div id="first" class="img">
            <div class="swiper-wrapper">
              <div class="swiper-slide flex"><img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E9%A6%96%E5%B1%8A%E5%9B%9E%E9%A1%BE/2019/%E5%8D%9A%E8%A7%88%E4%BC%9A%E7%85%A7%E7%89%87/%E8%BD%A8%E9%81%93%E4%BA%A4%E9%80%9A/961A1444.jpg"></div>
              <div class="swiper-slide flex"><img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E9%A6%96%E5%B1%8A%E5%9B%9E%E9%A1%BE/2019/%E5%8D%9A%E8%A7%88%E4%BC%9A%E7%85%A7%E7%89%87/%E8%BD%A8%E9%81%93%E4%BA%A4%E9%80%9A/961A1457.jpg"></div>
              <div class="swiper-slide flex"><img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E9%A6%96%E5%B1%8A%E5%9B%9E%E9%A1%BE/2019/%E5%8D%9A%E8%A7%88%E4%BC%9A%E7%85%A7%E7%89%87/%E8%BD%A8%E9%81%93%E4%BA%A4%E9%80%9A/961A1462.jpg"></div>
              <div class="swiper-slide flex"><img src="//itie-static.oss-cn-hangzhou.aliyuncs.com/PC%E7%AB%AF%E5%AE%98%E7%BD%91/%E9%A6%96%E5%B1%8A%E5%9B%9E%E9%A1%BE/2019/%E5%8D%9A%E8%A7%88%E4%BC%9A%E7%85%A7%E7%89%87/%E5%BF%AB%E9%80%92%E7%89%A9%E6%B5%81/1H3A0744.jpg"></div>
            </div>            
          </div>
        </router-link>
        <div class="news">
          <router-link tag="a" class="more" to="/news" >More >></router-link>
          <DTitle text="News"></DTitle>
          <div class="flex news-wrap">
            <router-link tag="a" :to="'/news/'+item.id" v-for="(item, index) in newsList" :key="index" class="item">
              <div class="fl img">
                <img class="fl" :src="item.logoUrl+'?x-oss-process=image/resize,w_90,h_70'">
              </div>
              <div class="text">
                <div class="h4">{{item.title}}</div>
                <p>{{$helper.formatTime(parseInt(item.pubDate), 'Y-M-D')}}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div> -->
    <br>
    <div class="thanks center">
      <div class="title fl">
        <img src="data:image/png;base64,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">
        Acknowledging Unit
      </div>
      <div class="mq-sp" id="mq-sp"  @mouseenter="mqFlag2 = true" @mouseleave="mqFlag2 = false">
        <div class="flex" id="mq-sp1">
          <div v-for="i in 168" :key="i" class="flex img">
            <img :src="'//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/鸣谢单位logo/2019/'+i+'.png?x-oss-process=image/resize,h_30'">
          </div>
        </div>
        <div class="flex" id="mq-sp2">
          <div v-for="i in 168" :key="i" class="flex img">
            <img :src="'//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/鸣谢单位logo/2019/'+i+'.png?x-oss-process=image/resize,h_30'">
          </div>
        </div>
      </div>
    </div>
    <br>
    <br>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mqFlag: false,
      mqFlag2: false,
      mqTimer: null,
      mqTimer2: null,
      show: false,
      bannerList: 0,
      bannerShow: 0,
      bannerTimer: null,
      timer: null,
      lastTime: 1607043600000,
      time: 1647478800000,
      d: '*',
      h: '*',
      m: '*',
      s: '*',
      showCount: false,
      newsList: [],
      locationList: [
        {
          tag: 'A',
          style: {'background': '#3CB7E6'},
          location: '1B-A',
          name: '轨道交通馆',
          tags: ['磁悬浮','市域铁路','地铁','城际铁路','轻轨','单轨','有轨电车','高速铁路','重载铁路'],
          sponsors: ['德国轨道工业协会','德国西门子','德国罗贝尔','德国克诺尔','德国马克斯博格','德国哈高','德国德希曼','隔而固（青岛）振动控制有限公司','上海电气泰雷兹交通自动化系统有限公司','瑞泰潘得路铁路技术有限公司','瑞士ELAG电子有限公司北京代表处','瑞士柏中紧固件','住友電気工業株式会社','瑞穗银行','大和房屋','中国中车集团有限公司','中国铁路通信信号股份有限公司','中国铁建股份有限公司','中国中铁股份有限公司','中铁工程装备集团有限公司','浙江交通集团','中铁检验认证中心有限公司','北京轨道交通技术装备集团有限公司','北京磁浮交通发展有限公司','河北京车轨道交通车辆装备有限公司','浙江众合科技股份有限公司','上海富欣智能交通控制有限公司','南京康尼机电股份有限公司','山东朗进科技股份有限公司','浙江得玛斯科技/德睿达电气公司','中唐空铁集团有限公司','资源公司与铁科院铁建所等科创成果展示联合体'],
        },{
          tag: 'B',
          style: {'background': '#23A689'},
          location: '1B-B',
          name: '航空馆',
          tags: ['航空制造产业','智慧机场智能化设备','临空经济','航空产业园'],
          sponsors: ['浙江省机场集团有限公司','华为技术有限公司','中航材航空救援股份有限公司','浙江省建德经济开发区（航空小镇）管委会','德清启航建设发展有限公司','浙江东华通用航空有限公司','范德兰德物流自动化系统(上海）有限公司','泰科安全设备（上海）有限公司','宝略科技（浙江）有限公司','德国NavVis GmbH','盛视科技股份有限公司','中国民航局第二研究所民航成都电子技术有限责任公司、空管工程技术研究所','北京旷视科技有限公司','万达信息股份有限公司','东华通用航空服务中心','浙江海卡飞宏航空技术有限公司','文罗拉航空科技（上海）有限公司','彩虹无人机科技有限公司','浙江点辰航空科技有限公司','上海鹍翔智能科技有限公司','浙江吉鑫祥新能源装备制造有限公司','宁波星箭航天机械有限公司','春秋航空日本株式会社','华夏通用航空有限公司','浙江省航空运动协会','杭州智翔航空技术有限公司','浙江德盛通用航空有限公司','法国Dassault Aviation公司'],
        },{
          tag: 'C',
          style: {'background': '#4A90E2'},
          location: '1C-C',
          name: '智慧交通馆',
          tags: ['交通智能化建设最新技术成果','智能网联汽车','新能源汽车','城市大交通建设成果和规划','公共交通及交通管理设备','智能停车解决方案'],
          sponsors: ['深圳成谷科技有限公司','北京星云互联科技有限公司','浙江浙大中控信息技术有限公司','杭州海康威视数字技术股份有限公司','北京万集科技股份有限公司','浙江电马云车科技有限公司','佛山市航标资讯有限公司','杭州图软科技有限公司','南京慧尔视智能科技有限公司','上海大学（浙江•嘉兴）新兴产业研究院','杭州市停车产业股份有限公司','中交信通网络科技有限公司','华为技术有限公司','商汤科技','安吉畅游汽车服务股份有限公司','浙江省交通规划设计研究院有限公司','阿里巴巴网络有限公司','中兴通讯股份有限公司','新华三技术有限公司','银江股份有限公司','浙江省交通科学研究院','交通运输部公路科学研究院'],
        },{
          tag: 'D',
          style: {'background': '#EC8F25'},
          location: '1C-D',
          name: '快递及现代物流馆',
          tags: ['物联网','物流信息化','智能仓储','自动化分拣','航空物流','港口物流','新能源物流及配套','无人车物流','物流金融','跨境电商物流'],
          sponsors: ['浙江亚太机电股份有限公司','浙江沈氏省心物流科技有限公司','国家交通物流信息平台','杭州美龙汽车有限公司（上汽红岩）','宁波中通物流集团有限公司','新船帮科技有限公司','意欧斯智能科技股份有限公司','浙江立通物流有限公司','浙江德邦物流有限公司','京东物流（浙江京鸿供应链管理有限公司）','浙江申通快递有限公司','壹米滴答供应链管理集团有限公司','中国邮政集团公司浙江分公司','浙江顺丰速运有限公司','江苏苏宁物流有限公司','杭州百世网络技术有限公司','圆通速递(物流)有限公司'],
        },{
          tag: 'E',
          style: {'background': '#468D41'},
          location: '1C-E',
          name: '智能装备馆',
          tags: ['智能制造设备','港航设备','船舶修造','海洋工程','钻探和生产平台','海洋开发设备','大型钢结构','工程机械'],
          sponsors: ['浙江省海港投资运营集团有限公司','上海振华重工(集团)股份有限公司','卡尔玛港口机械（深圳）有限公司','三一重工股份有限公司','青岛海西重机有限责任公司','中国重型汽车集团卡车股份有限公司','卡哥特科（上海）贸易有限公司','徐州集团工程机械股份有限公司','杭叉集团股份有限公司','上海川丰机电科技发展有限公司','武汉港迪电气有限公司','ABB（中国）有限公司','上海海得控制系统股份有限公司','苏州汇川技术有限公司','上海西井信息科技有限公司','杭州飞步科技有限公司','北京主线科技有限公司','弗兰德（中国）','品奇布班察工业制动设备','康稳移动供电设备（上海）有限公司','宁波国际物流发展股份有限公司'],
        },{
          tag: 'F',
          style: {'background': '#9A6ACC'},
          location: '1D-F',
          name: '5G应用馆',
          tags: ['5G技术','5G产品','5G车联网','云VR/AR'],
          sponsors: ['陕西华腾云物联网（西安交通大学）','牧月科技','5G智慧灯杆产业联盟（广州嘉源互联）','中国移动中移物联','中国信科集团','南京莱斯信息技术','上海复亚智能科技','杭州艾米机器人有限公司','北京仁信证科技有限公司（信长城）','北京邮电大学'],
        },{
          tag: 'G',
          style: {'background': '#BB3C29'},
          location: '1D-G',
          name: '浙江综合交通产业馆',
          tags: ['各地市综合交通产业园区','特色小镇','代表企业','重点招商项目','产业政策'],
          sponsors: ['国际航运服务集聚区','智慧交通装备','交通新材料新工艺','交通新型智库','嘉兴港区航空航天产业园','中国电科36所智慧交通','武汉导航院绍兴院有限公司','绍兴市城投建筑工业化制造公司','纳诺科技有限公司','中国移动绍兴公司','绍兴三花新能源汽车部件有限公司','绍兴索密克汽车配件有限公司','浙江上风高科专风实业有限公司','浙江上风高科专风实业有限公司','卧龙控股集团','浙江盾安轨道交通设备有限公司','浙江梅轮电梯股份有限公司','公铁联运港','金华新能源汽车小镇','万里扬','今飞凯达','中浙高铁轴承有限公司','浙江贝尔轨道装备有限责任公司','浙江华凯科技有限公司','常山众卡运力供应链管理有限公司','巨化物流公司','舟山世德物流公司','浙江易航海信息技术有限公司','宝山钢铁股份有限公司','吉利集团','台州酷车小镇','浙江永贵电器','浙江浩腾电子科技股份有限公司','浙江金马逊机械有限公司'],
        },{
          tag: 'H',
          style: {'background': '#CB9421'},
          location: '1D-H',
          name: '综交产业创新馆',
          tags: ['交通领域独角兽','新型优秀企业','专精尖项目','风投','基金','金融服务'],
          sponsors: ['浙江星宗新能源科技有限公司','深圳雅果智能科技有限公司','浙江盘云交通设备有限公司','浙江恩利交通设施有限公司','杭州远眺科技有限公司','公交云（杭州公共交通云科技有限公司）/杭州数知梦科技有限公司','上海正先电子科技有限公司','义乌晗琨电子科技有限公司','常州亿昶道路安全设施有限公司','北京今谷神箭测控技术研究所','上海钧正网络科技有限公司（哈啰出行）','浙江瓯越交建科技股份有限公司','浙江北斗卫星导航平台有限公司','浙江开山重工股份有限公司','浙江志高机械股份有限公司','红五环集团股份有限公司','浙江舜通出行科技有限公司','上海双百智能科技有限公司','浙江创泰科技有限公司','河北大地交通科技有限公司','宁波GQY视讯股份有限公司','杭州路检数字技术有限公司','未来交通研究院','宁波昂霖智能装备有限公司','中国交通建设股份有限公司','杭州伟耀环保科技有限公司','阿塞拜疆','卡塔尔航空','Lithuanian Railways','Klepeda Port Authority','AB Lietuvos paštas','Air BridgeCargo Airlines','7 Stars Express','GBK GmbH','Schneider Electric','UNIKAI Lagerei','Konecranes','United Global Logistics','Logistics Plus Inc','Port of Antwerp','boplan','COPRO Tech','Port Gdansk','Freight Systems Limited','KTZ-Freight Transportation JSC','Swiss Mail Solutions','MBD Design'],
        },{
          tag: 'P',
          style: {'background': '#3271B7'},
          location: '1A-A',
          name: '成果发布区',
          // tags: ['无人驾驶','车路协同','无人机配送','危险驾驶预警','远程驾驶'],
          sponsors: [],
        }
      ],
      aboutList: [],
      cur: 'A',
      swiper: null,
      thisYear: true
    }
  },
  created() {
    this.timer = setInterval(() => {
      let x = this.time - new Date().getTime()
      if (x <= 0) {
        this.showCount = false
        clearInterval(this.timer);
        this.timer = null;
        return
      } else {
        this.showCount = true
      }
      this.d = parseInt(x/86400000)
      this.h = parseInt((x%86400000)/3600000)
      this.m = parseInt((x%3600000)/60000)
      this.s = parseInt((x%60000)/1000)
    }, 1000);
  },
  mounted() {
    // eslint-disable-next-line
    // let first = new Swiper('#first', {
    //   loop: true,
    //   autoplay: true,
    // })
    // first.el.onmouseover = function(){
    //   first.autoplay.stop()
    // }
    // first.el.onmouseleave = function(){
    //   first.autoplay.start()
    // }
    setTimeout(() => {
      this.show = true
      setTimeout(() => {
        // eslint-disable-next-line
        this.swiper = new Swiper('#banner-id', {
          loop: true,
          autoplay: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        })
        this.swiper.el.onmouseover = function(){
          this.swiper.autoplay.stop()
        }
        this.swiper.el.onmouseleave = function(){
          this.swiper.autoplay.start()
        }
      }, 100);
    }, 500);
    this.initBannerLength()
    this.startTimer()
    this.getNews()
    let mqSp = document.getElementById('mq-sp')
    let mqSp1 = document.getElementById('mq-sp1')
    let mqSp2 = document.getElementById('mq-sp2')
    this.mqTimer2 = setInterval(() => {
      if (this.mqFlag2) {
        return
      }
      if (mqSp2.offsetHeight - mqSp.scrollTop <= 0) {
        mqSp.scrollTop -= mqSp1.offsetHeight
      } else {
        mqSp.scrollTop++
      }
    }, 50);
  },
  computed: {
    curInfo() {
      return this.locationList.filter(i=> i.tag == this.cur)[0]
    }
  },
  methods: {
    getNews() {
      this.$http.get('/meeting/news/page/wxff1c03d44d5b330b',{ // 普通新闻
        params: {
          page: 1,
          limit: 6,
          type: 0
        }
      }).then(res => {
        if (res.code === 0) {
          this.newsList = res.data.list
          let fixed = document.getElementById('mq-fixed')
          let wrap1 = document.getElementById('mq-wrap1')
          let wrap2 = document.getElementById('mq-wrap2')
          this.mqTimer = setInterval(() => {
            if (this.mqFlag) {
              return
            }
            if (wrap2.offsetWidth - fixed.scrollLeft <= 0) {
              fixed.scrollLeft -= wrap1.offsetWidth
            } else {
              fixed.scrollLeft++
            }
          }, 50);
        }
      })
      this.$http.get('/meeting/news/page/wxff1c03d44d5b330b',{ // 链接新闻
        params: {
          page: 1,
          limit: 20,
          type: 1
        }
      }).then(res => {
        if (res.code === 0) {
          this.aboutList = res.data.list
        }
      })
    },
    resetTimer() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer);
        this.bannerTimer = null;
        this.startTimer();
      }
    },
    initBannerLength() {
      this.bannerList = this.$refs.bannerList.getElementsByClassName('banner-item').length;
    },
    startTimer() {
      this.bannerTimer = setInterval(() => {
        if (this.bannerList - 1 > this.bannerShow) {
          this.bannerShow++
        } else {
          this.bannerShow = 0
        }
      }, 5000);
    },
    bannerPlay(flag) {
      if (flag) {
        this.startTimer()
      } else {
        clearInterval(this.bannerTimer)
        this.bannerTimer = null
      }
    },
    marqueeStop(dom) {
      dom.target.stop()
    },
    marqueeStart(dom) {
      dom.target.start()
    },
    full() {
      this.$Modal.confirm({
        title: '名额已满',
        content: '<p>参展商报名已满！</p>',
        onOk: () => {
        }
      })
    }
  },
  beforeDestroy() {
    if (this.mqTimer) {
      clearInterval(this.mqTimer);
      this.mqTimer = null;
    }
    if (this.mqTimer2) {
      clearInterval(this.mqTimer2);
      this.mqTimer2 = null;
    }
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.bannerTimer) {
      clearInterval(this.bannerTimer);
      this.bannerTimer = null;
    }
  }
}
</script>
<style lang="less" scoped>
.conut-enter {
  transform: translateX(50vw);
}
.conut-enter-activity {
  transform: translateX(0);
}
.banner-enter {
  transform: translateY(-610px);
}
.banner-enter-activity {
  transform: translateY(0);
}
.home {
  background: url('../assets/views_bg.png') no-repeat scroll bottom / 100%;
}
.share-warp {
  position: fixed;
  z-index: 1001;
  top: 100px;
  right: 40px;
  width: 46px;
  height: 204px;
  padding: 5px 0;
  border-radius: 46px;
  background: linear-gradient(180deg,rgba(3,112,222,1) 0%,rgba(1,64,127,1) 100%);
  .icon {
    cursor: pointer;
    position: relative;
    width: 25px;
    margin: 0 auto;
    height: 49px;
    border-bottom: 1px solid #0769CC;
    img {
      width: 24px;
      height: auto;
    }
    .qrcode-wrap {
      border-radius: 2px;
      top: 0;
      right: 44px;
      position: absolute;
      background: #FFF;
      height: 160px;
      width: 140px;
      display: none;
      padding: 5px;
      box-shadow: 0 0 6px #555;
      img {
        width: 130px;
        height: auto;
      }
      .desc {
        color: #125FAD;
        font-weight: bold;
        font-size: 14px;
        line-height: 12px;
        letter-spacing: 2px;
      }
    }
    .qrcode-wrap:hover {
      display: block;
    }
    .higher {
      height: 360px;
      width: 200px;
      padding: 10px 16px;
      padding-top: 5px;
      .title {
        font-weight: bold;
        padding: 2px 5px;
        text-align: center;
        margin: 10px 0;
        width: 80px;
        height: 24px;
        background: #D8E6F3;
        color: #125FAD;
        line-height: 21px;
        border-radius: 12px;
        font-size: 14px;
      }
      .row {
        line-height: 22px;
        font-size: 14px;
        img {
          position: relative;
          top: 2px;
          width: 14px;
          height: auto;
          margin-right: 3px;
        }
      }
    }
  }
  .icon:hover {
    .qrcode-wrap {
      display: block;
    }
  }
  .icon:last-child {
    border-bottom: none;
  }
}
.banner {
  height: 610px;
  position: relative;
  margin-bottom: 70px;
  background: url('//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/banner/banner_wide2024-1.png') no-repeat;
  background-position: center center;
  background-size: cover;
  img {
    position: absolute;
    height: 610px;
  }
  // img {
  //   height: 610px;
  //   width: auto;
  // }
  // .swiper-slide {
  //   overflow: hidden;
  // }
  // .curve {
  //   position: absolute;
  //   overflow: visible;
  //   background: url('../assets/curve.png') no-repeat scroll top center / 100% 100%;
  //   height: 100px;
  //   bottom: 10px;
  //   left: 0;
  //   right: 0;
  //   z-index: 1000;
  //   h2 {
  //     margin: 25px auto;
  //     line-height: 20px;
  //     text-align: center;
  //     color: #125FAD;
  //     letter-spacing: 3px;
  //   }
  //   .timer {
  //     div {
  //       width: 60px;
  //       height: 50px;
  //       line-height: 50px;
  //       text-align: center;
  //       font-size: 26px;
  //       font-weight: 500;
  //       color: #FFA53C;
  //       background: #E6F6FE;
  //       margin: 0 10px;
  //     }
  //     .timer2 {
  //       font-size: 16px;
  //       color: #125FAD;
  //       line-height: 40px;
  //       background: none;
  //     }
  //   }
  // }
}
.no-count {
  height: 610px;
  margin-bottom: 0;
}
.sign-wrap {
  padding: 30px 0;
  background: #F3F3F3;
  .centerr {
    max-width: 1080px;
    width: 100%;
    justify-content: space-between;
  }
  .sign-item {
    transition: all ease-out 0.2s;
    background: linear-gradient(#1A85F3, #1B2295);
    cursor: pointer;
    position: relative;
    justify-content: space-around;
    width: 250px;
    height: 100px;
    border-radius: 4px;
    padding: 0 45px;
    img {
      height: 40px;
      width: auto;
      margin-right: 10px;
    }
    h4 {
      color: #FFF;
      font-size: 20px;
      font-weight: 500;
      line-height: 30px;
    }
    .lt {
      position: absolute;
      left: 0;
      top: 0;
    }
    .rt {
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
  .sign-item:last-child {
    background: linear-gradient(#FFD127, #E55808);
  }
  .sign-item:hover {
    transform: scale(1.05);
  }
}
.mq-fixed {
  width: 900px;
  margin-left: 20px;
  line-height: 90px;
  height: 90px;
  overflow: hidden;
}
.marquee {
  height: 90px;
  .flag {
    width: 160px;
    height: 40px;
    border-radius: 40px;
    background: linear-gradient(to right, #0069D4, #152B8D);
    font-size: 16px;
    color: #FFF;
    line-height: 42px;
    text-align: center;
    font-weight: bolder;
    letter-spacing: 1px;
    img {
      position: relative;
      width: 20px;
      height: auto;
      top: 3px;
      margin-right: 8px;
    }
  }
  marquee {
    margin-left: 35px;
    line-height: 90px;
    a {
      font-size: 16px;
      font-weight: 400;
      margin: 0 20px;
      color: #666;
    }
  }
  a {
    font-size: 16px;
    color: #125FAD;
    width: 80px;
    text-align: right;
  }
}
.about {
  height: 302px;
  border: 1px solid #0769CC;
  border-radius: 3px;
  position: relative;
  .banner-wrap {
    position: relative;
    height: 300px;
    width: 1080px;
    .banner-item {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: all 1s;
      visibility: hidden;
      opacity: 0;
      .banner-content {
        cursor: pointer;
        position: relative;
        height: 100%;
        width: 100%;
        margin: 0 auto;
        .img {
          width: 540px;
          height: 300px;
          border-radius: 3px;
          background-repeat: no-repeat;
          background-size: cover;
        }
        .text {
          width: 540px;
          height: 300px;
          padding: 25px 25px;
          text-indent: 32px;
          h2 {
            font-size: 18px;
            line-height: 32px;
          }
          p {
            font-size: 16px;
            text-align: justify;
          }
        }
      }
    }
    .item-show {
      visibility: visible;
      opacity: 1;
    }
  }
  .banner-legend {
    position: absolute;
    z-index: 2;
    right: 20px;
    bottom: 20px;
    div {
      height: 14px;
      width: 14px;
      border-radius: 2px;
      border: 1px solid #0769CC;
      margin: 0 5px;
      border-radius: 100%;
      transition: all 0.5s;
      cursor: pointer;
    }
    .cur {
      transition: all 0.5s;
      border: 1px solid #0769CC;
      background: #0769CC;
    }
  }
}
.annual-info {
  margin: 45px 0;
  // background: url('../assets/maze_bg.svg') repeat-x;
  .center {
    justify-content: space-between;
    .first {
      height: 300px;
      width: 400px;
      .img {
        margin-top: 20px;
        width: 400px;
        height: 240px;
        overflow: hidden;
        img {
          width: 400px;
          height: 240px;
          // transition: all ease-out 0.2s;
        }
        // img:hover {
        //   transform: scale(1.05);
        // }
      }
    }
    .news {
      position: relative;
      height: 300px;
      width: 650px;
      .more {
        position: absolute;
        right: 0;
        top: 2px;
        font-size: 14px;
        color: #0769CC;
      }
      .news-wrap {
        margin-top: 20px;
        height: 240px;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        .item {
          display: block;
          width: 280px;
          height: 70px;
          margin-bottom: 15px;
          margin-right: 40px;
          .img {
            // overflow: hidden;
            img {
              width: 90px;
              height: 70px;
              border-radius: 3px;
              transition: all ease-out 0.2s;
            }
          }
          .text {
            padding-left: 100px;
            padding-top: 4px;
            .h4 {
              font-size: 13px;
              height: 35px;
              color: #333;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            p {
              margin-top: 10px;
              font-size: 13px;
              color: #666;
            }
          }
        }
        .item:hover {
          img {
            transform: scale(1.05);
          }
          .text {
            .h4 {
              color: #125FAD;
              transition: all ease-in-out 0.3s;
            }
          }
        }
      }
    }
  }
}
.thanks::before {
  content: "";
  display: table;
}
.thanks {
  height: 180px;
  background: #F7F7F7;
  .title {
    width: 50px;
    height: 180px;
    background: linear-gradient(to right, #0069D4, #152B8D);
    writing-mode: tb-rl;
    text-align: center;
    color: #FFF;
    line-height: 50px;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 6px;
    border-radius: 3px;
    img {
      width: 23px;
      height: auto;
    }
  }
  .mq-sp {
    overflow: hidden;
    height: 160px;
    width: 1030px;
    margin: 10px 0;
    margin-left: 50px;
    padding: 10px;
    .flex {
      width: 1010px;
      flex-wrap: wrap;
      .img {
        width: 120px;
        height: 40px;
        img {
          max-width: 100px;
          max-height: 30px;
        }
      }
    }
  }
}
.plan {
  height: 650px;
  .tab {
    .item {
      cursor: pointer;
      width: 110px;
      height: 90px;
      text-align: center;
      margin: 0 5px;
      opacity: 0.5;
      .img {
        margin: 10px auto;
        height: 46px;
        width: 75px;
        line-height: 46px;
        text-align: center;
        font-size: 26px;
        font-weight: bolder;
        color: #FFF;
      }
      .desc {
        font-size: 12px;
        color: #333;
      }
    }
    .cur{
      opacity: 1;
      .desc {
        font-weight: bolder;
      }
    }
  }
  .info {
    height: 320px;
    padding-bottom: 20px;
    .fl {
      position: relative;
      width: 640px;
      height: 304px;
      background: url('//itie-static.oss-cn-hangzhou.aliyuncs.com/PC端官网/场馆图例/背景.png') no-repeat scroll top center / 100% 100%;
      .block {
        cursor: pointer;
        position: absolute;
      }
      .A {
        left: 205px;
        top: 147px;
        width: 85px;
        height: 35px;
      }
      .B {
        left: 215px;
        top: 103px;
        width: 80px;
        height: 40px;
      }
      .C {
        left: 328px;
        top: 165px;
        width: 90px;
        height: 30px;
      }
      .D {
        left: 325px;
        top: 132px;
        width: 83px;
        height: 30px;
      }
      .E {
        left: 322px;
        top: 100px;
        width: 80px;
        height: 26px;
      }
      .F {
        left: 452px;
        top: 170px;
        width: 86px;
        height: 26px;
      }
      .G {
        left: 443px;
        top: 134px;
        width: 80px;
        height: 34px;
      }
      .H {
        left: 425px;
        top: 100px;
        width: 80px;
        height: 34px;
      }
      .P {
        left: 85px;
        top: 145px;
        width: 90px;
        height: 40px;
      }
      img {
        width: 640px;
        height: 304px;
      }
    }
    .desc {
      padding-left: 700px;
      padding-top: 50px;
      .hall-wrap {
        width: 300px;
        .hall {
          padding-left: 10px;
          width: 120px;
          height: 46px;
          float: left;
          color: #FFF;
          border-radius: 46px;
          line-height: 46px;
          font-size: 24px;
          text-align: center;
          background: #CCC;
          div {
            float: right;
            font-size: 14px;
            width: 50px;
            line-height: 18px;
            margin: 5px 0;
          }
        }
        .name {
          position: relative;
          top: 6px;
          margin-left: 150px;
          padding-left: 25px;
          width: 200px;
          border-left: 1px solid #E3E3E3;
          height: 34px;
          line-height: 34px;
          font-size: 18px;
          color: #0769CC;
          font-weight: 500;
        }
      }
      marquee {
        overflow: hidden;
        margin-top: 20px;
        height: 200px;
      }
      .tag-wrap {
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-top: 20px;
        width: 100%;
        .tag {
          padding: 6px 10px;
          text-align: center;
          font-size: 14px;
          color: #0769CC;
          line-height: 26px;
          border: 1px solid #EAEAEA;
          margin: 5px 10px;
          background: #FFF;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>
